import '@testing-library/jest-dom';
import { render, screen } from '@testing-library/react';

import { AppStatusBar } from './AppStatusBar';

describe('AppStatusBar', () => {
  it('should render', () => {
    render(<AppStatusBar message="AppStatusBar message" severity="info" />);
    expect(screen.getByText('AppStatusBar message')).toBeInTheDocument();
  });
});
